export type GpxPoint = { lat: number; lng: number }

export function parseGpxRoute(gpxText: string): GpxPoint[] | null {
  try {
    if (!gpxText) {
      return null
    }
    const doc = new DOMParser().parseFromString(gpxText, 'text/xml')
    if (doc.getElementsByTagName('parsererror').length > 0) {
      return null
    }
    const trkpts = doc.querySelectorAll('trkpt')
    const elements = trkpts.length > 0 ? trkpts : doc.querySelectorAll('rtept')
    const points: GpxPoint[] = []
    elements.forEach((el) => {
      const lat = parseFloat(el.getAttribute('lat') ?? '')
      const lng = parseFloat(el.getAttribute('lon') ?? '')
      if (!isNaN(lat) && !isNaN(lng)) {
        points.push({ lat, lng })
      }
    })
    if (points.length === 0) {
      return null
    }
    return points
  } catch {
    return null
  }
}
